import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Colors, H3, Icon, Spinner } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';

import { IState } from '../../shared/store/reducers';
import { ApiStatus } from '../../shared/models';
import { fetchActivities } from '../../shared/store/actions/activityActions';
import RecentActivity from './RecentActivity';

const Loading = () => <>
  <div className="home__content__block__item ">
    <div className="home__content__block__item__name block-loading bp4-skeleton" />
  </div>
  <div className="home__content__block__item ">
    <div className="home__content__block__item__name block-loading bp4-skeleton" />
  </div>
  <div className="home__content__block__item ">
    <div className="home__content__block__item__name block-loading bp4-skeleton" />
  </div>
</>;

const RecentActivityList = () => {
  const recentActivities = useSelector((state: IState) => state.activities.results);
  const loadingStatus = useSelector((state: IState) => state.activities.loadingStatus);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchActivities());
  }, []);

  const noActivity =
    !recentActivities || (recentActivities && !recentActivities.length);

  return (
    <div className="home__content__block">
      <div className="home__content__block__header">
        <Icon
          icon={IconNames.UPDATED}
          size={18}
          color={Colors.GRAY3}
          className="home__content__block__header__icon"
        />
        Recently Viewed
      </div>

      <Card className="home__content__block__card">
        <div className="home__content__block__list">
          {loadingStatus === ApiStatus.LOADING ? (
            <Loading />
          ) :
            (noActivity ? (
              <div className="home__content__block__nodata">
                <Icon icon={IconNames.TIME} color={Colors.GRAY3} size={60} />
                <H3>No Recent Activity</H3>
                <p>You haven't viewed any reports yet.</p>
              </div>
            ) : (
              recentActivities.map((activity: any) => {
                if (!activity.item) {
                  return null;
                }

                return (
                  <RecentActivity
                    key={activity.item.uid}
                    activity={activity}
                  />
                )
              })
            ))}
        </div>
      </Card>
    </div>
  );
};

export default RecentActivityList;
